import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const Login = lazy(() => import('./components/Login'))
const Callback = lazy(() => import('./components/Callback'))
const ForgotPassword = lazy(() => import('./components/ForgotPassword'))

const AuthModule: RouteObject = {
    path: '',
    children: [
        {
            path: 'login',
            element: <Login />,
        },
        {
            path: 'callback',
            element: <Callback />,
        },
        {
            path: 'forgot',
            element: <ForgotPassword />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AuthModule
